// extracted by mini-css-extract-plugin
export default {"errorPage":"ErrorPage_errorPage__HlRWn","errorText":"ErrorPage_errorText__Dw3eW"};